'use client';

import {styled} from '@mui/material';

export const StyledHr = styled('hr')(({ theme }) => ({
  width: '100%',
  height: '2px',
  border: 'none',
  backgroundColor: theme.palette.background.separator,
  marginBottom: '3rem',
  opacity: 0.15,
  [theme.breakpoints.down('md')]: {
    marginBottom: '2rem',
  },
}));
